_ = require 'underscore'
makeErrorEnum = require 'lib/make-error-enum'

PluginModelSerializerError = makeErrorEnum 'PluginModelSerializer', [
  'InvalidField'
]

readJSONFields = (json, allowedFields, fields) ->
  if _.any(fields, (field) -> field !in allowedFields)
    throw PluginModelSerializerError.InvalidField()

  _.pick(json, fields)

readModelFields = (model, allowedFields, fields, getters = {}) ->
  if _.isEqual(['all'], _.values(fields))
    fields = allowedFields
  _.chain(fields)
  .map (field) ->
    if field !in allowedFields
      throw PluginModelSerializerError.InvalidField()

    value = if getters[field]?
      getters[field](model, field)
    else
      model.get(field)

    [field, value]
  .object()
  .value()

serializePreview = (preview, fields = ['bytes', 'height', 'scaled', 'url', 'width']) ->
  readJSONFields preview, ['bytes', 'height', 'scaled', 'url', 'width'], fields

serializePreviews = (previews, fields) ->
  previews.map _.partial(serializePreview, _, fields)

serializeAttachment = (attachment, fields = ['id', 'url', 'name', 'edgeColor', 'previews']) ->
  readModelFields attachment, ['id', 'url', 'name', 'edgeColor', 'previews'], fields,
    previews: ->
      # We load the previews asynchronously, so we might not have them yet
      serializePreviews(attachment.get('previews') ? [])

serializeAttachments = (attachments, fields) ->
  attachments.map _.partial(serializeAttachment, _, fields)

serializeBoard = (board, fields = ['id', 'name']) ->
  allowed = [
    'id',
    'name',
    'url',
    'shortLink',
    'members',
    'dateLastActivity',
    'idOrganization'
  ]
  readModelFields board, allowed, fields,
    members: ->
      serializeMembers(board.memberList, ['all'])

serializeOrganization = (organization, fields = ['id']) ->
  readModelFields organization, ['id', 'name'], fields

serializeCard = (card, fields = ['id', 'name']) ->
  allowed = [
    'attachments',
    'badges',
    'closed',
    'cover',
    'dateLastActivity',
    'desc',
    'due',
    'dueComplete',
    'id',
    'idList',
    'idShort',
    'labels',
    'members',
    'name',
    'shortLink',
    'url'
  ]
  readModelFields card, allowed, fields,
    attachments: ->
      serializeAttachments(card.attachmentList)

    cover: ->
      if (idAttachmentCover = card.get('idAttachmentCover'))?
        if (cover = card.attachmentList.get(idAttachmentCover))?
          return serializeAttachment(cover)

      null

    labels: ->
      serializeLabels(card.labelList)

    members: ->
      serializeMembers(card.memberList, ['all'])

serializeCards = (cards, fields = ['id', 'name']) ->
  cards.map _.partial(serializeCard, _, fields)

serializeLabel = (label, fields = ['name', 'color']) ->
  readModelFields label, ['name', 'color'], fields

serializeLabels = (labels, fields) ->
  labels.map _.partial(serializeLabel, _, fields)

serializeList = (list, fields = ['id', 'name']) ->
  readModelFields list, ['id', 'name', 'cards'], fields,
    cards: ->
      serializeCards(list.cardList.models, ['all'])

serializeLists = (lists, fields = ['id', 'name']) ->
  lists.map _.partial(serializeList, _, fields)

serializeMember = (member, fields = ['id', 'fullName', 'username']) ->
  readModelFields member, ['id', 'fullName', 'username', 'initials', 'avatar'], fields,
    avatar: ->
      avatarHash = member.get('avatarHash')
      if avatarHash
        return [window.avatarDomain, avatarHash, '170.png'].join('/')
      null

serializeMembers = (members, fields) ->
  members.map _.partial(serializeMember, _, fields)

module.exports =
  Error: PluginModelSerializerError
  attachment: serializeAttachment
  attachments: serializeAttachments
  board: serializeBoard
  card: serializeCard
  cards: serializeCards
  list: serializeList
  lists: serializeLists
  member: serializeMember
  organization: serializeOrganization



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-model-serializer.coffee